import { gql } from "@apollo/client";

export const CREATE_MASTER_DATA_RETAILER_MATCH_RULE = gql`
  mutation CreateMasterDataRetailerMatchRule(
    $params: CreateMasterDataRetailerMatchRuleInput!
  ) {
    createMasterDataRetailerMatchRule(params: $params) {
      ruleId
      retailerId
      matchPattern
      matchPriority
      sourceColumn
      retailerName
    }
  }
`;

export const UPDATE_MASTER_DATA_RETAILER_MATCH_RULE = gql`
  mutation UpdateMasterDataRetailerMatchRule(
    $params: UpdateMasterDataRetailerMatchRuleInput!
  ) {
    updateMasterDataRetailerMatchRule(params: $params) {
      ruleId
      retailerId
      matchPattern
      matchPriority
      sourceColumn
      retailerName
    }
  }
`;
